import { motion } from "framer-motion";
import { EASE } from "./Reveal";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 1, delay, ease: EASE },
});

export const ParentBrand = () => (
  <section id="group" className="relative overflow-hidden border-t border-white/10 py-28 md:py-36" data-testid="parent-brand-section">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-emerald-500/10 blur-[120px]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <motion.p {...fade()} className="eyebrow text-center">The group</motion.p>
      <div className="mt-16 grid grid-cols-1 items-center gap-14 lg:grid-cols-[1fr_auto_1fr] lg:gap-16">
        <motion.div {...fade(0.1)} className="flex justify-center lg:justify-end">
          <img src="/images/pluk-logo.png" alt="PLUK Innovative Headhunting logo" className="w-[78%] max-w-[460px]" data-testid="parent-pluk-logo" />
        </motion.div>
        <motion.div {...fade(0.25)} className="flex flex-row items-center justify-center gap-4 lg:flex-col">
          <span className="h-px w-16 bg-gradient-to-r from-transparent to-emerald-400 lg:h-24 lg:w-px lg:bg-gradient-to-b" />
          <span className="font-display whitespace-nowrap text-2xl italic text-emerald-300">a unit of</span>
          <span className="h-px w-16 bg-gradient-to-l from-transparent to-emerald-400 lg:h-24 lg:w-px lg:bg-gradient-to-t" />
        </motion.div>
        <motion.div {...fade(0.4)} className="flex justify-center lg:justify-start">
          <img src="/images/anweta-logo.png" alt="Anweta Ventures Private Limited logo, Integrity At Work" className="w-[62%] max-w-[340px]" data-testid="parent-anweta-logo" />
        </motion.div>
      </div>
      <motion.p {...fade(0.5)} className="mx-auto mt-16 max-w-2xl text-center text-base md:text-lg leading-relaxed text-zinc-300" data-testid="parent-brand-copy">
        PLUK HR Services is the HR services and executive search unit of Anweta Ventures Private Limited, built on the
        group's founding principle of <span className="text-emerald-300">Integrity At Work.</span>
      </motion.p>
    </div>
  </section>
);
